import { render } from "./Maindetails.vue?vue&type=template&id=1040449a&scoped=true"
import script from "./Maindetails.vue?vue&type=script&lang=js"
export * from "./Maindetails.vue?vue&type=script&lang=js"

import "./Maindetails.vue?vue&type=style&index=0&id=1040449a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1040449a"]])

export default __exports__